import React from 'react';
import PropTypes from 'prop-types';
import Calendar from 'components/Calendar';

const DatePickerCalendar = (props) => {
  const {
    value,
    className,
    handleChange,
    minDate,
    maxDate,
    close,
    calendarModifiers,
    disableWeekends,
    disabledDays,
  } = props;
  return (
    <div className={className}>
      <Calendar
        selectedDays={value}
        minDate={minDate}
        maxDate={maxDate}
        handleChange={handleChange}
        modifiers={calendarModifiers}
        close={close}
        disableWeekends={disableWeekends}
        disabledDays={disabledDays}
      />
    </div>
  );
};

DatePickerCalendar.propTypes = {
  value: PropTypes.instanceOf(Date),
  handleChange: PropTypes.func,
  close: PropTypes.func,
  minDate: PropTypes.instanceOf(Date).isRequired,
  maxDate: PropTypes.instanceOf(Date),
  className: PropTypes.string,
  calendarModifiers: PropTypes.arrayOf(PropTypes.string),
};

DatePickerCalendar.defaultProps = {
  value: null,
  handleChange: () => {},
  close: () => {},
  className: '',
};

export default DatePickerCalendar;
